export * from './useProductDetailsRemoteData.ts';
